module.exports = __webpack_public_path__ + "img/mobile-15.2319de7b.png";